import _axios from 'axios';
import get from 'lodash/get';

import { clientError as _clientError } from '../../../lib/errorReporting';
import { analyticsPayload, callbackWithTimeout } from '../../../lib/analytics';

export const BEGIN_ADD_ITEM_TO_CART = 'BEGIN_ADD_ITEM_TO_CART';
export const COMPLETE_ADD_ITEM_TO_CART = 'COMPLETE_ADD_ITEM_TO_CART';
export const ERROR_ADDING_TO_CART = 'ERROR_ADDING_TO_CART';

const defaultState = {
  busy: false
};

export const reducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case BEGIN_ADD_ITEM_TO_CART:
      return { ...state, busy: true };
    case ERROR_ADDING_TO_CART:
      return { ...state, busy: false };
    case COMPLETE_ADD_ITEM_TO_CART: {
      const newState = { ...state, busy: false };
      const count = get(action, 'payload.count', null);

      if (count) {
        return { ...newState, count };
      }

      return newState;
    }
    default:
      return state;
  }
};

export const beginAddItemToCart = () => ({
  type: BEGIN_ADD_ITEM_TO_CART
});

export const completeAddItemToCart = count => ({
  type: COMPLETE_ADD_ITEM_TO_CART,
  payload: { count }
});

export const errorAddingToCart = () => ({
  type: ERROR_ADDING_TO_CART
});

const redirectToCart = ({ history, location }) => {
  if (location.state && location.state.modal) {
    history.goBack();
  }

  setTimeout(() => {
    window.location.pathname = '/cart';
  }, 0);
};

export const logATC = (
  client,
  { productTypeId, priceAmount, work },
  callback = () => {}
) => {
  client.setEnhancedEcommerceAddProduct(
    analyticsPayload.enhancedEcommerceProduct(
      work,
      productTypeId,
      priceAmount,
      1
    )
  );

  client.logEventWithCallback(
    analyticsPayload.addToCart(productTypeId, priceAmount),
    callbackWithTimeout(callback)
  );
};

export const addItemToCart = (
  {
    inventoryItem,
    price: { amount: priceAmount },
    history,
    location,
    redirect = true
  },
  { axios = _axios, clientError = _clientError } = {}
) => (dispatch, getState, { analytics }) => {
  dispatch(beginAddItemToCart());

  const { productTypeId, work, id: inventoryItemId } = inventoryItem;

  return axios
    .post('/explore/cart/items', { inventoryItemId })
    .then(response => {
      const count = get(response, 'data.cart.count', null);

      dispatch(completeAddItemToCart(count));

      // TODO REMOVE THIS AND REFACTOR ASAP
      // eslint-disable-next-line no-undef
      if (typeof dataLayer !== 'undefined') {
        // eslint-disable-next-line no-undef
        dataLayer.push({
          event: 'product-add-to-cart'
        });
      }

      if (analytics) {
        logATC(
          analytics,
          {
            productTypeId,
            priceAmount,
            work,
            history,
            location
          },
          redirect ? () => redirectToCart({ history, location }) : () => {}
        );
      } else if (redirect) {
        redirectToCart({ history, location });
      }
    })
    .catch(error => {
      dispatch(errorAddingToCart());
      clientError(error);
    });
};
